import { network } from 'services/network';

import { QueryParams, QueryResponse } from 'api/queries/getSchedulingSimulationResults.query';

export const getSchedulingSimulationResult = (params: QueryParams): Promise<QueryResponse> => {
    return network.post('api/bo/getSchedulingSimulationResult', params).then((response) => {
        return response.data;
    });
};
